import type { ReactNode } from 'react'

import { NavItemSwitch } from '@/shared/access'

import { classBrowserNav, classBrowserVisibilityApi, isClassBrowserVisible } from './learner'

/** Shows "Browse Classes" in the nav only while the viewer's organization has its class browser switch on, as legacy's menu does. */
export function ClassBrowserMenuProvider(props: { readonly children: ReactNode }) {
  return (
    <NavItemSwitch item={classBrowserNav} path={classBrowserVisibilityApi} isOn={isClassBrowserVisible}>
      {props.children}
    </NavItemSwitch>
  )
}
